export default {
      id: "health-care-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#health-care",
      toString: function () {
        return this.url;
      }
    }